import { render, staticRenderFns } from "./HomeAnnouncements.vue?vue&type=template&id=5d9292ec&scoped=true&"
import script from "./HomeAnnouncements.vue?vue&type=script&lang=js&"
export * from "./HomeAnnouncements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9292ec",
  null
  
)

export default component.exports